<template>
  <v-card class="mx-auto mt-16" width="512px">
    <v-card-title>
      Sign in
    </v-card-title>

    <v-card-text>
      <v-form>
        <v-text-field
          label="Username"
          prepend-icon="mdi-account-circle"
          v-model="username"
        />
        <v-text-field
          v-bind:type="showPassword ? 'text' : 'password'"
          label="Password"
          prepend-icon="mdi-lock"
          v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          v-on:click:append="showPassword = !showPassword"
          v-model="password"
        />
      </v-form>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer />

      <v-btn
        color="primary"
        v-on:click="signin"
        v-bind:loading="loading"
      >
        Sign in
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// TODO: Maybe do it with a dialog?

export default {
  name: 'Signin',
  data () {
    return {
      showPassword: false,
      username: '',
      password: '',
      loading: false,
    }
  },
  methods: {
    async signin () {
      if (!this.username) {
        this.$store.dispatch('updateMessage', {
          text: 'Username must not be empty',
          type: 'error'
        })
      } else if (!this.password) {
        this.$store.dispatch('updateMessage', {
          text: 'Password must not be empty',
          type: 'error'
        })
      } else {
        this.loading = true

        let success = await this.$store.dispatch('signin', {
          username: this.username,
          password: this.password
        })
        
        this.loading = false

        if (success) {
          this.$router.push('/app')
        }
      }
    }
  }
}
</script>
